import Axios from 'axios';
import { Payload } from '../constants/payload.model';

const RYVUSS_API = `${process.env.VUE_APP_RYVUSS_API}`;

const apiProxy = (options) => {
    try {
        return Axios.post('/ProxyApi', options);
    } catch (error) {
        throw new Error(error);
    }
};


export default {
    async getListingCount(SellerId) {

        SellerId = SellerId ? SellerId.toString().toUpperCase() : SellerId;

        const options = new Payload(`${RYVUSS_API}/seo-chileautos/listing?q=(And.SellerId.CL-SELLER-${SellerId}._.Servicio.ChileAutos.)&sr=|||&count=true&ids=true`, 'GET');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if(error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
                
            throw new Error(error);
        }
    },
}